import { useEffect, useRef } from 'react'

interface ElementVisibleProps {
  onVisible?(): void
  onNotVisible?(): void
  options?: IntersectionObserverInit
}

export const useElementVisible = ({
  onVisible,
  onNotVisible,
  options,
}: ElementVisibleProps) => {
  const elementRef = useRef<HTMLDivElement>(null)
  const lastVisible = useRef(false)

  useEffect(() => {
    const bottom = elementRef.current
    const observer = new IntersectionObserver(
      async (entries) => {
        const entry = entries[0]

        const rect = entry.boundingClientRect

        const visible =
          rect.top <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.left <=
            (window.innerWidth || document.documentElement.clientWidth) &&
          rect.bottom >= 0 &&
          rect.right >= 0
        const last = lastVisible.current
        lastVisible.current = visible
        if (last === visible) return
        if (visible) onVisible?.()
        else onNotVisible?.()
      },
      { root: null, threshold: 0, ...options }
    )
    if (bottom) observer.observe(bottom)
    return () => {
      if (bottom) observer.unobserve(bottom)
    }
  }, [onVisible, onNotVisible, options])

  return {
    elementRef,
  }
}
